import { AiOutlineHome } from "react-icons/ai";
import { Logo, MaterielCarousel, SlideImg } from "./assets";
import {
  MdLogout,
  MdPersonOutline,
  MdOutlineBook,
  MdLibraryBooks,
  MdOutlinePeople,
} from "react-icons/md";

const footer = {
  box1: {
    title: "contact",
    name: "Unité de Recherche en Génie des Procédés et en Génie de l’Environnement (URGPGE)",
    adress: "Faculté des sciences de l’Université d’Antananarivo",
    email: "contact@urgpge-ua.mg",
    tel: "(+261) 32 45 129 23",
  },
  box2: {
    title: "espace reserver",
    link: [
      {
        path: "/auth?l=true",
        text: "Se connecter",
      },
      {
        path: "/auth?l=false",
        text: "S'inscrire",
      },
      {
        text: "Se Déconnecter",
      },
      { path: "/dashboard", text: "Compte utilisateur" },
    ],
  },
};

const auth = {
  signIn: {
    title: "Connexion",
    form: [
      {
        label: "E-mail ou Nom d'utilisateur",
        type: "text",
        placeholder: "ex: rakoto@gmail.com ou rakoto",
        name: "userFind",
        required: true,
      },
      {
        label: "Mot de passe",
        type: "password",
        placeholder: "Mot de passe",
        name: "password",
        required: true,
      },
    ],
    submit: "Se connecter",
    link: {
      path: "/auth?l=false",
      text: "Vous n'avez pas de compte?",
      a: "S'inscrire",
    },
  },
  signUp: {
    title: "Inscription",
    form: [
      {
        type: "text",
        label: "Nom d'utilisateur",
        placeholder: "ex: rakoto",
        name: "username",
        required: true,
      },
      {
        type: "text",
        label: "Nom",
        placeholder: "ex: RANDRIA",
        name: "lastname",
        required: true,
      },
      {
        type: "text",
        label: "Pénom",
        placeholder: "ex: Rakoto André",
        name: "firstname",
        required: false,
      },
      {
        type: "email",
        label: "Email",
        placeholder: "ex: rakotoandre@gmail.com",
        name: "email",
        required: true,
      },
      {
        type: "password",
        label: "Mot de passe",
        placeholder: "Mot de passe",
        name: "password",
        required: true,
      },
      {
        type: "password",
        label: "Confirmation du mot de passe",
        placeholder: "Confirmation du mot de passe",
        name: "passwordConfirm",
        required: true,
      },
      {
        type: "radio",
        label: "Votre niveau",
        name: "graduate",
        required: false,
        options: [
          {
            value: "Etudiant",
            label: "Etudiant",
          },
          {
            value: "Pr",
            label: "Professeur",
          },
          {
            value: "Dr",
            label: "Docteur",
          },
        ],
      },
      {
        type: "select",
        label: "Votre spécialité",
        name: "speciality",
        required: false,
        options: [
          {
            value: "Chimie",
            label: "Chimie",
          },
          {
            value: "Eau et Environement",
            label: "Eau et Environement",
          },
          {
            value: "Génie des procédés",
            label: "Génie des procédés",
          },
          {
            value: "Bioprocédés",
            label: "Bioprocédés",
          },
        ],
      },
      {
        type: "text",
        label: "Numéro de téléphone",
        placeholder: "+261 00 00 000 00",
        name: "tel",
        required: false,
      },
    ],
    submit: "Inscrire",
    link: {
      path: "/auth?l=true",
      text: "Vous avez un compte?",
      a: "Se connecter",
    },
  },
};

const navbar = {
  logo: {
    path: "/",
    img: Logo,
    alt: "URGPGE-logo",
  },
  menu: [
    {
      name: "Accueil",
      path: "/",
      down: false,
      drop: [],
    },
    {
      name: "Laboratoire",
      down: true,
      drop: [
        // {
        //   name: "Emplois & Stage",
        //   path: "/offres",
        // },
        {
          name: "Présentation",
          path: "/presentation",
        },
        {
          name: "Formation",
          path: "/formation",
        },
        // {
        //   name: "Actualités",
        //   path: "/actualites",
        // },
      ],
    },
    {
      name: "Thèses en cours",
      path: "/recherche",
      down: false,
      drop: [],
    },
    {
      name: "Publication",
      down: true,
      drop: [
        {
          name: "Thèses",
          path: "/theses",
        },
        {
          name: "Articles",
          path: "/articles",
        },
        // {
        //   name: "Press & Média",
        //   path: "/press_media",
        // },
      ],
    },
    {
      name: "Contact",
      down: true,
      drop: [
        {
          name: "Annuaire",
          path: "/contact/annuaire",
        },
        {
          name: "Nous contactez",
          path: "/contact/nous-contactez",
        },
      ],
    },
  ],
};

const hero = {
  SlideData: SlideImg,
  content: {
    title:
      "Unité de Recherche en Génie des Procédés et en Génie de l’Environnement.",
    text: "Le centre de Recherche et d’Etudes en Génie de l’Eau et de l’Environnement CREG2E est un laboratoire d’analyses environnementales ...",
    btn: {
      text: "Plus",
      path: "/presentation",
    },
  },
};

const formation = {
  title_page: "Master en Génie de l’Eau et génie de l’environnement",
  title: "Présentation de la formation",
  master_present: {
    title: "Ce master propose 2 spécialités différents",
    data: [
      {
        title: "Eau et environnement",
        text: "Il relève l’analyse, traitement et valorisation de tout type de pollution (en phase liquide, solide et gazeuse). Cela concerne les procédés de traitement des eaux résiduaires en générale (industrielles, urbaines), des eaux potables, dessalement, etc…",
      },
      {
        title: "Génie des procédés",
        text: "C’est une spécialisation assez générale et pluridisciplinaire. Ses compétences techniques et théorique principales concernent les phénomènes de transport des matières, la cinétique chimique, la thermodynamique et la modélisation d’un phénomène. Ces bases permettent de dimensionner et contrôler le procédé. Le domaine concerné tourne autour des industries de transformation et formulation dans le secteur agro-alimentaire, pharmaceutique, chimie industrielle.",
      },
    ],
    suplement: [
      {
        text: "Durée de la formation",
        span: "2ans",
      },
      {
        text: "Niveau de sortie",
        span: "Bac +5",
      },
    ],
  },
  apres: {
    title: "Et après ?",
    competence: {
      title: "Compétences acquis après la formation",
      data: [
        "Maitrise du domaine des procédés appliqués à l’eau et à l’environnement",
        "Capacité à la valorisation des déchets et des biomasses",
        "Maîtrise en système de management d’Hygiène, Sécurité, Qualité et Environnement (HSQE)",
        "Maîtrise du domaine des procédés appliqués à la biotechnologie et pharmaceutique",
        "Concevoir, piloter et coordonner la mise en œuvre et amélioration des procédés industriels de transformation de la matière et de l’énergie par application de connaissances pluridisciplinaires, théoriques et expérimentaux",
        "Montage d’un projet professionnel",
      ],
    },
    poursuit: {
      title: "Poursuites d’étude ? débouchés professionnels ?",
      text: "La formation vise des postes cadre dans le département recherche et développement des sociétés de traitement des effluent (eau, air, sol), épuration des eaux et dans l’industrie de procédés chimique, responsable de laboratoire d’analyse et de contrôle, … ou la poursuite d’étude vers la recherche (doctorat dans l’école doctorale Science de la Vie et de l’Environnement (SVE) de la Faculté des Sciences de l’université d’Antananarivo).",
    },
  },
  admission: {
    title: "Condition d’accès",
    text: "La première année de master est accessible sur dossier aux candidats ayant un diplôme de licence académique en chimie ou équivalent.",
  },
  programme: {
    title: "Programme",
    table: {
      semestre_8: [
        {
          intitules_des_unites_d1enseignement: "Base du Génie des Procédés",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement:
            "Techniques moderne d’extraction et de préparation d’échantillon (air, eau, sol, sédiment, boue)",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement: "Traitements des eaux",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement:
            "Traitement membranaire et échanges d’ions",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement:
            "Réacteurs chimiques hétérogènes",
          credits: 6,
        },
      ],
      semestre_9: [
        {
          intitules_des_unites_d1enseignement:
            "Sécurité et développement durable",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement:
            "Traitements des déchets solides et traitements des gaz",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement:
            "Pollution et dépollution des sols et nappes",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement: "Management et Economie",
          credits: 6,
        },
        {
          intitules_des_unites_d1enseignement: "Bioprocédés et biotechnologies",
          credits: 6,
        },
      ],
      semestre_10: [
        {
          intitules_des_unites_d1enseignement:
            "Stage d’application donnant lieu à un mémoire et une soutenance orale",
          credits: 30,
        },
      ],
    },
  },
};

const homeFormation = {
  title: "Nos Formation",
  content: [
    {
      name: "Master I",
      path: "/formation/master1",
    },
    {
      name: "Master II",
      path: "/formation/master2",
    },
  ],
};

const presentation = {
  presentation: {
    title: "Présentation de l'unité",
    text: "Le centre de Recherche et d’Etudes en Génie de l’Eau et de l’Environnement CREG2E est un laboratoire d’analyses environnementales.",
  },
  siege: "Faculté des sciences de l’Université d’Antananarivo.",
  activity: {
    title: "Activités",
    text: "Le Laboratoire de CREG2E accueille des étudiants en stage de fin d’études dans le domaine de CHIMIE et travail aussi avec les industries en résolvant leurs problématiques environnementales. L’expertise comprend des  études sur terrain, le diagnostic  et le traitement si nécessaire.",
    list: [
      {
        data: "Eaux (Caractérisations, potabilisations, traitements)",
      },
      {
        data: "Sols (Caractérisations, traitements)",
      },
      {
        data: "Air (Caractérisations, traitements)",
      },
      {
        data: "Déchets (Caractérisations, traitements)",
      },
    ],
  },
  equipement: {
    title: "Matériels et équipements ",
    carousel: {
      data: MaterielCarousel,
      title: "Images matériels",
    },
    subTitle1: {
      title: "Analyses physico-chimiques et bactériologiques",
      span: "eaux et matrices solides après minéralisation",
    },
    table: {
      analyses_physicochimiques: [
        {
          parametres: "Echantillonnage",
          methodes_analytiques: [
            "Flacons : flacons en verre",
            "Profondeur : 0,5  - 1,5 m",
            "Conservation : Température constante",
          ],
          reference: [""],
        },
        {
          parametres: "pH",
          methodes_analytiques: ["Méthode électrométrique"],
          reference: ["MA. 100 – pH 1.1"],
        },
        {
          parametres: "Conductivité",
          methodes_analytiques: ["Méthode électrométrique"],
          reference: ["MA. 115 – Cond. 1.1"],
        },
        {
          parametres: "Température",
          methodes_analytiques: ["Méthode électrométrique"],
          reference: [""],
        },
        {
          parametres: "Couleur",
          methodes_analytiques: [
            "Méthode par spectrophotométrie UV-visible avec le platino-cobalt",
          ],
          reference: ["MA. 103 – Col. 2.0"],
        },
        {
          parametres: "Turbidité",
          methodes_analytiques: ["Méthode néphélémétrique"],
          reference: ["MA. 103 – Tur. 1.0"],
        },
        {
          parametres: "Ions (anions, cations)",
          methodes_analytiques: [
            "Dosage par chromatographie ionique avec détecteur conductivimétrique et/ou par spectrométrie UV",
          ],
          reference: ["MA. 303 – Anions 1.1", "MA. 300 – Ions 1.3"],
        },
        {
          parametres: "Ammoniac",
          methodes_analytiques: ["Méthode colorimétrique"],
          reference: ["MA. 300 – N 2.0"],
        },
        {
          parametres: "Azote total Kjeldahl et du phosphore total",
          methodes_analytiques: [
            "Digestion acide",
            "Méthode colorimétrique automatisée",
          ],
          reference: ["MA. 300 – NTPT 2.0"],
        },
        {
          parametres: "MES",
          methodes_analytiques: ["Méthode par filtration sur papier"],
          reference: [""],
        },
        {
          parametres: "DBO5",
          methodes_analytiques: ["Méthode électrométrique"],
          reference: ["MA. 315 – DBO 1.1"],
        },
        {
          parametres: "DCO",
          methodes_analytiques: [
            "Méthode de reflux en système fermé suivi d'un dosage par colorimétrie avec le bichromate de potassium",
          ],
          reference: ["MA. 315 – DCO 1.1"],
        },
        {
          parametres: "Huiles et graisses",
          methodes_analytiques: ["Méthode gravimétrique"],
          reference: ["MA. 400 – HGT 1.1"],
        },
        {
          parametres: "Hydrocarbures Totaux, Composés phénoliques",
          methodes_analytiques: [
            "Dosage par chromatographie en phase gazeuse couplée à un détecteur à ionisation de flamme",
          ],
          reference: ["MA. 400 – HYD. 1.1"],
        },
        {
          parametres: "Métaux lourds",
          methodes_analytiques: ["Polarographie / chromatographie ionique"],
          reference: [""],
        },
      ],
      analyses_microbiologiques: [
        {
          parametres: "Coliformes et Streptocoques fécaux et totaux",
          methodes_analytiques: [
            "Recherche avec le milieu de culture : méthode présence/absence",
          ],
          reference: ["MA. 700 – Col 1.0"],
        },
        {
          parametres: "Escherichia coli",
          methodes_analytiques: [
            "Recherche avec le milieu de culture : méthode présence/absence",
          ],
          reference: ["MA. 700 – Ecct 1.0"],
        },
        {
          parametres: "Coliformes fécaux thermotolérants",
          methodes_analytiques: ["Méthode par filtration sur membrane"],
          reference: ["MA. 700 – Fec.Ec 1.0"],
        },
      ],
    },
    subTitle2: {
      title: "Equipement de simulation pour le traitement des eaux",
      list: [
        {
          data: "Clarification",
        },
        {
          data: "Décantation",
        },
        {
          data: "Ultrafiltration",
        },
        {
          data: "Charbon actif",
        },
        {
          data: "....",
        },
      ],
    },
  },
};

const articleFixture = {
  btn: {
    path: "/articles",
    text: "Voir plus",
  },
  title: "publication",
  data: [
    {
      path: "/articles/1",
      auteur: "Julie Tantely Mitantsoa",
      title:
        "Elaboration and characterization of bioplastic films based on bitter cassava starch (Manihot esculenta) reinforced by chitosan extracted from crab (Shylla seratta) shells",
      subTitle:
        "Pierre Hervé Ravelonandro, Fara Arimalala Andrianony, Rajaona Rafihavanana Andrianaivoravelona.",
      abstract: `Bioplastics are polymer plastics which are derived from renewable biomass resources. In
      this study, bioplastic films based on two different polysaccharides such as bitter cassava starch and
      chitosan extracted from crab shells were produced by casting technique, using glycerol as plasticizer.
      The purposes of this research are to characterize and to figure out the effect of additional chitosan
      concentrations (0; 10; 20; 30; 50% by weight of starch) on the physicochemical, mechanical and
      water barrier properties of bioplastic films. The film’s solubility in water (S), water absorption
      capacity (WAP), water vapor permeability (WVP), tensile strength (TS), elongation at break (E),
      Young’s modulus (YM) and biodegradability were investigated. The possible interactions between
      starch and chitosan molecules were evaluated by Fourier transform infrared spectroscopy (FTIR).
      From the analysis, the incorporation of the chitosan shows improved results on the water barrier
      properties of the bioplastic films. Optimum solubility in water, water absorption capacity, and water
      vapor permeability are obtained on the composition of starch/chitosan was 50/50. Actually, the
      addition of chitosan increased tensile strength, and elongation at break. The characterization of
      optimum mechanical proprieties also occurred on the 50/50 composition of cassava-starch and
      chitosan. At this ratio, tensile strength obtained were 6,3000 MPa; and the elongation at break were
      62,8571%. It was found that cassava-starch/chitosan-based films have a stable structure compared to
      native cassava-starch films.`,
      journal:
        "International Journal of Science, Engineering and Technology. 9(6).",
      link: "https://www.ijset.in/wp-content/uploads/IJSET_V9_issue6_501.pdf",
      keywords: [
        "Chitosan",
        "Thermoplastic starch",
        "Starch-chitosan films",
        "Bioplastic",
        "Mechanical properties",
        "Biodegradable films",
      ],
      categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
      date: new Date("1 december 2021"),
    },
    {
      path: "/articles/2",
      auteur: "Andrianony Fara Arimalala",
      title:
        "Modeling and kinetics study of Avocado oil extraction from Madagascar using different mathematical models",
      subTitle: "Ravelonandro Pierre Hervé, Rajaona Rafihavanana.",
      abstract: `Avocado pulp contains variable oil contents, and is widely used in human nutrition, pharmaceutical and cosmetic industries. This study aims to determine and verify the effects of temperatures (60 °C, 65 °C, 70 °C) and reaction times (6 h, 9 h and 12 h) on the solid liquid extraction of three varieties of oil (Fuerte, Fucca, Bacon) of avocado (Persea americana) from Madagascar. Then, kinetic of oil extraction of one the three varieties, notably the Bacon as most content oil between the three varieties has been investigated using Soxhlet and hexane as solvents to extract oil. Different mathematical models based on second order, Peleg's and logarithmic models could describe the extraction process of avocado. The kinetic of oil extraction from avocado oil by solvent extraction proved that the second order model with high R<sup>2</sup> value of 0,9979 is better than Peleg's with R<sup>2</sup> value 0,861 and logarithmic model with R<sup>2</sup> value 0,893. Therefore, it can be assumed that, comparing the results of both kinetic models (Peleg's and logarithmique models), the second order kinetic model represents well the experimental results of the avocado oil extraction. The optimum condition on yield oil for all varieties (Fuerte, Fucca and Bacon) was found at 70 °C and 12 h (58,14%, 33%, 61,51%).`,
      journal: "South African Journal of Chemical Engineering 41, 93-97.",
      link: "https://doi.org/10.1016/j.sajce.2022.05.006",
      keywords: [
        "Avocado oil",
        "Kinetic",
        "Solvent",
        "Extraction",
        "Mathematical models",
      ],
      categories: "Génie des procédés",
      date: new Date("1 may 2022"),
    },
    {
      path: "/articles/3",
      auteur: "Andrianaivoravelona Rafihavanana Rajaona",
      title:
        "Contamination by NOx type Pollutants in the Leach Ate from the Andralanitra Garbage Dump (Antananarivo Madagascar)",
      subTitle:
        "Pierre Hervé Ravelonandro, Julie Tantely Mitantsoa, Fara Arimalala Andrianony.",
      abstract: `The study concerns the analysis of physic-chemical parameters in order to establish the state of pollution of a garbage dump site. The interpretation of the data is done by standardized principal component analysis. Thus, leachate samples were taken at 9 study stations in wet and dry periods. The results show that among the parameters studied, there is a high content of BOD5 (592,035 mg/L), EC (16,786 mS/cm) and COD (1373,684 mg/L). The concentration level of nitrates and nitrites greatly exceeds the norm; for the old landfill, the NO<sub>2-</sub> contents vary from 191,527 mg/L to 875,206 mg/L and the NO<sub>3-</sub> ranging from 384,926 mg/L to 1584,021 mg/L, we thus observe the influence of humidity on the concentrations of physic-chemical parameters. Furthermore, the chemical composition and mass concentrations of pollutants at the sites are highly dependent on the nature of the waste and the degree of pollution differs from one site to another. The considerable increase in the content of these pollutants is favored by bacterial activities during the transformation of the organic matter present in the leachate. However, the importance of the degree of contamination of the landfill favoring the pollution of the receiving environment is confirmed.`,
      journal:
        "European Journal of Environment and Earth Sciences. 3 (3) 13-18.",
      link: "https://doi.org/10.24018/ejgeo.2022.3.3.271",
      keywords: [
        "Antananarivo",
        "Contamination",
        "Landfills",
        "Leachates",
        "Physic-chemical parameters",
        "Principal component analysis",
      ],
      categories: "Eau et environnement",
      date: new Date("24 may 2022"),
    },
    {
      path: "/articles/4",
      auteur: "Elando Fréda ZAMANILEHA",
      title:
        "Evaluation of the vulnerability of groundwater to nitrogen pollution in the commune of Mananara Avaratra by the SINTACS method.",
      subTitle: "Yves Jean Michel MONG, Pierre RAVELONANDRO.",
      abstract: `The urban commune of Mananara Avaratra, located on the east coast of Madagascar in the Analanjirofo region, is characterized by
      alluvial soils, mainly sandy and ferruginous, and a tropical climate.Groundwater is considered as the main source of drinking water for the local population although the presence of pollution by nitrogen compounds has been a serious environmental problem for more than a decade This study aimed at developing a groundwater vulnerability model for nitrate and ammonium as a protective measure. Based on the intrinsic vulnerability determined by the SINTACS model, the influence of anthropogenic parameters related to nitrogen sources and groundwater use on contamination was verified using GIS. Chemical analyses showed high concentrations of nitrate (136.987 mg.l<sup>-1</sup>) and ammonium (1.120 mg.l<sup>-1</sup>) in the samples. The high nitrate and ammonium concentrations were found in the northern subwatershed, probably due to the area impacted by urbanization by urbanization, where the groundwater vulnerability index is high (high index is 197 - 210 and for the very high ones 215 - 223).
      On the other hand, the concentrations in the southern subwatershed are lower, and the index is moderate (137 - 178). In order to prevent the contamination of groundwater by nitrogen, it is necessary to develop management policies on surface land use and groundwater, as well as to continuously monitor the latter.`,
      journal:
        "International Journal of Scientific & Engineering Research (IJSER). ISSN 2229-5518. 13 (6) 949-956.",
      link: "https://doi.org/10.14299/ijser.2022.06.06 ",
      keywords: [
        "Ammonium",
        "Mananara Avaratra",
        "Nitrate",
        "SINTACS",
        "Subwatershed",
        "Vulnerability",
      ],
      categories: "Eau et environnement",
      date: new Date("1 june 2022"),
    },
    {
      path: "/articles/5",
      auteur: "Vandanjon Laurent",
      title:
        "The Use of FTIR Spectroscopy as a Tool for the Seasonal Variation Analysis and for the Quality Control of Polysaccharides from Seaweeds.",
      subTitle:
        "Burlot Anne-Sophie, Zamanileha Elando Fréda, Douzenel Philippe, Ravelonandro Pierre Hervé, Bourgougnon Nathalie, Bedoux Gilles",
      abstract: `Macroalgae are a potentially novel source of nutrition and biologically active molecules. Proliferative species such as Eucheuma denticulatum, Solieria chordalis (red algae) and Sargassum muticum (brown alga) constitute a huge biomass that can be exploited. In this study, we focus on the extraction of polysaccharides from these three macroalgae species and the characterization of cell wall polysaccharides such as carrageenans, fucoidans and alginates by Fourier Transform Infrared spectroscopy with Attenuated Reflectance Module (FTIR-ATR). The comparison of purified extracts with commercial solutions of fucoidans, alginates or carrageenans shows a strong similarity between the spectra. It demonstrates that the methods of extraction that have been used are also suitable purifying technics. Moreover, it validates infrared spectroscopy as a quick, simple and non-destructive method for the accurate analysis of polysaccharides. The FTIR technique applied to samples collected at different periods of the year allowed us to highlight differences in the composition of fucoidans, alginates and carrageenans. Different classes corresponding to the season can be distinguished by statistical multidimensionnal analysis (Principal Component Analysis) showing that the structure of algal polysaccharides, related to bioactivity, depends on the period of harvest. FTIR results showed that S. chordalis and E. denticulatum possess a dominant type of carrageenan called iota-carrageenan. This type of carrageenan is in the majority when the alga is at maturity in its development cycle. During its growth phase, iota-carrageenan precursors can be detected by FTIR spectra, enabling a better control of the extraction and an application of these compounds in various economic sectors. When the alga E. denticulatum is in its juvenile stage, we found traces of kappa-carrageenan and nu-carrageenan polysaccharides in some extracts.`,
      journal: "Marine Drugs, 21 (9), 482",
      link: "https://doi.org/10.3390/md21090482 ",
      keywords: [
        "FTIR spectroscopy",
        "Eucheuma denticulatum",
        "Solieria chordalis",
        "Sargassum muticum",
        "carrageenans",
        "fucoidans",
        "alginates",
        "seasonal variation",
      ],
      categories: "Chimie appliquée & Biotechnologie",
      date: new Date("1 september 2023"),
    },
    {
      path: "/articles/6",
      auteur: "Razafintsalama A. Rija",
      title:
        "Efficient Photocatalytic Reduction of Hexavalent Chromium by BiVO<sub>4</sub>- Decorated MXene Photocatalysts and Their Charge Carrier Dynamics.",
      subTitle:
        "Mishra Rajashree P., Sahoo Manas K., Mrinalini Madoori, Sahoo Bismaya, Ravelonandro Pierre, Chaudhary Yatendra S.",
      abstract: `The synergistically MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) co-catalyst-decorated BiVO<sub>4</sub>- based heterostructured photocatalysts have been synthesized by a hydrothermal approach with varied loading concentrations of MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) to drive the hexavalent chromium reduction efficiently. The formation of the heterostructured photocatalyst was confirmed by the appearance of X-ray diffraction (XRD) peaks corresponding to the monoclinic BiVO<sub>4</sub> phase and MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) and also the antisymmetric (834 cm<sup>–1</sup>) and symmetric stretching (715 cm<sup>–1</sup>) of tetrahedral VO4 and D (1330 cm<sup>–1</sup>) and G (1570 cm<sup>–1</sup>) bands corresponding to MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) in the Raman spectrum. The worm-like structures of BiVO<sub>4</sub> nanocrystals grew onto the lamellar sheets of MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>), as shown by field emission scanning electron microscopy (FESEM), and has an increased surface area of 15.62 m<sup>2</sup>g<sup>–1</sup> in the case of BVO-20-TC. X-ray photoelectron spectroscopy (XPS) analysis confirms the presence of V<sup>5+</sup> and Ti<sup>3+</sup>states, and the uniform distribution of BiVO<sub>4</sub> nanocrystals over lamellar sheets of MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) is evident from energy-dispersive X-ray (EDX) analysis. The ultraviolet-diffuse reflectance spectroscopy (UV-DRS) spectra suggest a decrease in the band gap energy of BVO-20-TC to 2.335 eV, promoting a higher degree of visible light harvesting. Upon optimization, by varying the pH, the amount of the photocatalyst, and the concentration of Cr(IV), BVO-20-TC exhibits the highest photocatalytic efficiency (96.39%) while using a Cr(VI) concentration of 10 ppm at pH 2 and 15 mg of the photocatalyst, and the photoreduction of Cr(VI) to Cr(III) follows the pseudo-first-order reaction. The decrease in the PL intensity in BVO-20-TC reveals a faster transfer of electrons from MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) to BiVO<sub>4</sub>. Further, the higher degree of band bending at the BiVO<sub>4</sub>/MXene (Ti<sub>3</sub>C<sub>2</sub>T<sub>x</sub>) heterojunction, revealed from the Mott–Schottky analysis, facilitates efficient charge transfer and eventually faster and efficient photoreduction of Cr(VI) to Cr(III). The reusability and stability test undertaken for BVO-20-TC reveals that even after five cycles, the Cr (VI) photoreduction efficacy is retained. This work provides insights into photoreduction of Cr (VI) by using such heterostructures.`,
      journal: "Langmuir, 39 (36), 12725–12739.",
      link: "https://doi.org/10.1021/acs.langmuir.3c01462",
      keywords: [
        "Electrical conductivity",
        "Heterostructures",
        "Photocatalysis",
        "Photocatalysts",
        "Two dimensional materials",
      ],
      categories: "Eau et environnement",
      date: new Date("1 september 2023"),
    },
    {
      path: "/articles/7",
      auteur: "Rajaona Andrianaivoravelona Rafihavanana",
      title:
        "Feasibility Study of the Implementation of a Wastewater Treatment Plant in the City of Tulear Madagascar 2018.",
      subTitle:
        "Ravelonandro Pierre Hervé, Ravaloera Antsatiana, Andriamanampisoa Lova Marcellin",
      abstract: `The city of Tulear is undergoing environmental degradation. The wastewater is heavily polluted, the average values observed for biological oxygen demand (282,347 ± 76,907 mg.L<sup>-1</sup>), chemical oxygen demand (579,302 ± 161,102 mg.L<sup>-1</sup>), and suspended solids (859,114 ± 816,707 mg.L<sup>-1</sup>) are above the standard discharge values. This study allowed us to design a treatment system and to make a technical, economic, environmental and social assessment of the treatment plant. Thus, the treatment method chosen is the physico-chemical process of coagulation – flocculation –filtration. Indeed, for a population of 368,020 inhabitants, the average hourly discharge rate is estimated at 662.436 m<sup>3</sup>/d. In addition, the number of bars for grids n°1 and n°2 are respectively 34 and 140, the surface of the sedimentation basin is estimated at 204,5m<sup>2</sup>, the optimal dose of coagulant (Al<sub>2</sub>(SO<sub>4</sub>)<sub>3</sub>) and flocculant (polyacrylamide) for the coagulation-flocculation basin are respectively 300 mg.L<sup>-1</sup> and 2 mg.L<sup>-1</sup> and this gives a considerable drop in suspended solids of the order of 15,22 mg.L<sup>-1</sup> after treatment. For the settling basin, the volume of clarifier is estimated at 306,68m<sup>3</sup>, finally the sludge produced is estimated at 1613,66 m<sup>3</sup>.`,
      journal: "European Journal of Environment and Earth Sciences 4 (4), 1–8",
      link: "https://doi.org/10.24018/ejgeo.2023.4.4.410",
      keywords: [
        "BOD",
        "Coagulation",
        "COD",
        "Decantation",
        "Flocculation",
        "Madagascar",
        "MS",
        "Treatment Station",
        "Tulear",
      ],
      categories: "Eau et environnement",
      date: new Date("4 july 2023"),
    },
    {
      path: "/articles/8",
      auteur: "Rajoelisoa Andriamalala",
      title:
        "The Use of Allochthonous Tropical Peat Swamps of Antananarivo for Dyes Elimination in Effluents.",
      subTitle: "Ravelonandro Pierre Hervé",
      abstract: `Textile industries play an important role in the economy of developing countries. However, these industries are among the major consumers of water and chemical inputs. They reject considerable quantities of wastewater, the quality of which sometimes threatens the environment due to the inefficiency of the treatment methods used. This is combined with the inaccessibility to the advanced purification technologies because of their high cost. Many low-cost materials have been studied by scientists to treat effluents. The ATP (allochthonous tropical peat) of Antananarivo, Madagascar, has aroused interest in the treatment of wastewater, especially for colored textile effluents. The physico-chemical characteristics of the ATP are determined, then the BLM dye (methylene blue) is used as a model dye for adsorption. After that, treatment tests in the form of filtration are carried out with textile effluent. This study showed that ATP removes cationic dyes more favorably than anionic ones at pH greater than 4.2, the zero-charge point of peat. The adsorption of BLM, a cationic dye, on ATP is physisorption and endothermic. A maximum of 20mg of BLM dye is adsorbed per gram of ATP and its follows the Langmuir model. The analysis of the IR spectra showed that the carboxylic function and the phenol group of the peat are involved on the dye fixation. The treatment of effluent taken from the textile industry revealed that ATP improves the pH and the color of the effluent; however, it increases the COD due to the presence of certain organic acids.`,
      journal: "Asian Journal of Environment & Ecology, 19(4), 9–20",
      link: "https://doi.org/10.9734/ajee/2022/v19i4415",
      keywords: [
        "Tropical-peat",
        "Adsorption",
        "Textile-dyes",
        "Wastewater",
        "Pollution",
        "Antananarivo",
      ],
      categories: "Eau et environnement",
      date: new Date("2022-11-21"),
    },
    {
      path: "/articles/9",
      auteur: "Elando Fréda ZAMANILEHA",
      title:
        "Various Approaches to Fourier-Transform Infrared Spectroscopy (FTIR) for Bioanalytical and Biotechnological Applications in Marine Algae",
      subTitle:
        "Julie Tantely Mitantsoa, Picardino Frienduc Vaonalamihanta, Andriamanarivosoa Rija Razafintsalama, Fara Arimalala Andrianony and Pierre Hervé Ravelonandro",
      abstract: `In recent decades, infrared spectroscopy has proved to be an effective tool for studying biological molecules, thanks in particular to advances in Fourier transform infrared (FTIR) spectroscopy. This method is widely used to characterize molecules, providing precise data on samples and finding extensive applications in biological and biotechnological research. Macroalgae, alongside marine crustaceans, are now recognized as primary sources of biomass, offering nutritional benefits and promising bioactive molecules. Hydrocolloids extracted from algae play a crucial role as food additives, improving the texture and quality of food products. This chapter explores in detail the fundamentals, data analysis methods, spectrum interpretation, and associated aspects of characterizing hydrocolloids present in the cell wall of algae using FTIR spectroscopy. It provides an in-depth overview of the methodologies used to extract these hydrocolloids from various types of algae while optimizing analytical techniques and interpreting infrared results. By enriching our understanding of these compounds, this chapter aims to promote their use in diverse fields such as food and biotechnology, highlighting their growing potential as sustainable and biologically beneficial resources.
      </br>
      <a href="http://dx.doi.org/10.5772/intechopen.1006723" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">DOI: 10.5772/intechopen.1006723</a></br>
      <h4>ISBN 978-0-85014-920-3</h4>
      <h5>London, UK</h5>`,
      journal: "IntechOpen",
      link: "https://www.intechopen.com/online-first/1197231",
      keywords: [
        "FTIR",
        "hydrocolloids",
        "infrared",
        "macroalgae",
        "polysaccharides",
        "spectra",
      ],
      categories: "Chimie appliquée & Biotechnologie",
      date: new Date("2024-10-01"),
    },
    {
      path: "/articles/10",
      auteur: "Elando Fréda ZAMANILEHA",
      title: `Biochemical Composition and Seasonal Variations of the Madagascar Algae <i>Eucheuma denticulatum</i> (<i>Solieriaceae</i>, Rhodophyta)`,
      subTitle:
        "Anne-Sophie Burlot, Thomas Latire, Christel Marty, Philippe Douzenel, Laurent Vandanjon, Nathalie Bourgougnon, Pierre Ravelonandro, Gilles Bedoux",
      abstract: `Although the density and diversity of seaweeds in Madagascar is particularly high, these resources are underexploited and they are not part of the local population’s eating habits. No study has been carried out on the nutritional properties and seasonal variation of <i>Eucheuma</i> species harvested in Madagascar. In this study, <i>Eucheuma denticulatum</i> was harvested monthly over two years (2021 and 2022) on the northeast coast of Madagascar (Sainte Marie Island). The compositional analysis revealed prominent sugars and minerals up to 41.0 and 39.5% dw, respectively. <i>E. denticulatum</i> showed slight variability over the seasons in the macroelements and oligoelements (Ca, K, Na, Mg, Fe, Mn) ranging from 22.8 ± 0.2 to 25.3 ± 0.1% dw in 2021 and 22.1 ± 0.3 to 26.5 ± 0.3% dw in 2022. Total amino acids varied from 2.3 ± 0.6 to 2.5 ± 0.6% dw during the two years. Seaweed extracts showed antioxidant activity by the in vitro method ranging from 2026 ± 2 to 2998 ± 4 μg.mL<sup>-1</sup> in 2021, and from 1904 ± 2 to 2876 ± 4 μg.mL<sup>-1</sup> in 2022. Finally, the principal component analysis (PCA) showed a correlation between protein content and environmental parameters. The nutritional characteristics therefore confirmed that <i>E. denticulatum</i> could potentially be used as a nutritious and functional food and could be incorporated in the diet of local populations.
      </br>
      <a href="https://doi.org/10.3390/md23010030" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">DOI: 10.3390/md23010030</a>`,
      journal: "Mar. Drugs 2025, 23(1), 30",
      link: "https://doi.org/10.3390/md23010030",
      keywords: [
        "Antioxidant",
        "Eucheuma denticulatum",
        "Madagascar",
        "Monosaccharide",
        "Nutrition",
        "Seasonal variation",
      ],
      categories: "Chimie appliquée & Biotechnologie",
      date: new Date("2025-01-09"),
    },
    {
      path: "/articles/11",
      auteur: "Julie Tantely MITANTSOA",
      title: `Microbial production of thermoplastic-targeted biopolymer composites made of polyhydroxybutyrate and protein by <i>Cupriavidus necator</i> CECT 4623 strain: Bacterial accumulation, thermal characterizations, direct extrusion processing and mechanical properties`,
      subTitle:
        "Xavier Cameleyre, Carole Molina Jouve, Philippe Evon, Guadalupe Vaca-Medina, Pierre Hervé Ravelonandro",
      abstract: `The production of biobased and degradable materials has become crucial facing the urgent need to reduce plastic pollution. Polyhydroxyalkanoates (PHA) production from the microbial conversion of renewable resources, proven to be environmentally friendly plastics, represents major environmental and economic challenges replacing petrochemical-based plastics. The biggest challenges for PHA industrialization include their high production cost. This study explored a new way to overcome this economic bottleneck by directly processing bacterial biomass containing polyhydroxybuturate (PHB) and protein in its entirety through direct extrusion of post-culture recovered biomass. The physical properties of biopolymers, including PHB and proteins, produced by <i>Cupriavidus necator</i> CECT 4623 strain were evaluated for thermoplastic purposes. The direct processing of dry and wet biomasses with various PHB/protein mass ratios was investigated to quantify the impact of these ratios and the water content in the biomass on the mechanical properties of the materials when the whole cells content with six different mass ratios of PHB versus protein were 48.8/39.6, 51.3/43.2, 55.3/40.1, 56.1/36.1, 61.9/33.2, and 71.7/24.3, using a micro- compounder. The results revealed the role of proteins and residual water in the cells on the final product properties. Avoiding expensive downstream processes such as drying and purification steps, this new way to produce bio-based materials is very promising, with increasing technical and economic viability compared to previous works. All prepared composites in this work should be biodegradable at the end of their life, as both biopolymers, i.e., PHB and proteins, as well as the other components of the biomass, are bio-based and biodegradable.
      </br>
      <a href="https://doi.org/10.1016/j.mtcomm.2025.112277" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">10.1016/j.mtcomm.2025.112277</a>`,
      journal: "Materials Today Communications 45, 112277",
      link: "https://doi.org/10.1016/j.mtcomm.2025.112277",
      keywords: [
        "Polyhydroxyalkanoates",
        "Protein",
        "Biomass",
        "Fermentation",
        "Extrusion",
        "Biopolymers",
        "Biocomposites",
      ],
      categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
      date: new Date("2025-04-01"),
    },
    {
      path: "/articles/12",
      auteur: "Franck Cloreil Eboa Mbonjo",
      title:
        "Design of an Intermittent Biosand Filter Amended with Oyster Shell Powders for the Improvement of Household Water Quality in Sub-Saharan Africa and Madagascar",
      subTitle:
        "Hervé Pierre Ravelonandro, Suzanne Boum-Nkot Ngo, Rodrigue Seth Ebonji, Rodrigue Seth Ebonji, Rajaona Fiahavanana Andrianaivoravelona, François Tchoumbougnang",
      abstract: `Access to safe drinking water and the wide spread of water-borne diseases are major challenges in Sub-Saharan Africa and Madagascar. Based on this, a water purification models has been developed which can use on a local scale. It consists of an intermittent biosand filter amended with oyster shell powders designed from local materials. The performance of the filter was evaluated through physicochemical and bacteriological analyses using standardized methods on raw polluted well water with previously determined initial D0 characteristics. The effectiveness of the designed filter was assessed and a filtration operation was carried out over a monitoring period of 13 days (D13) prior to 7 days of acclimatization of the system. With a filtration rate of 0.75l/h<sup>-1</sup>, there is a very strong reduction in turbidity from 35.59NTU to 0 NTU and in BOD5 from 125mg/l to 2mg/l. More so, bacteriological analyses reveal a progressive and complete decrease from D0 to D13 of fecal coliforms from 9000 CFU/100ml to 0 CFU/100ml; total coliforms from 6,000 CFU/100 ml to 0 CFU/100 ml and fecal streptococci from 10,800 CFU/100 ml to 0 CFU/100 ml. Compared to the classic ceramic filter, no significant difference in the Duncan test is reported for the highlighted parameters. This filter presents potential among other water treatment methods at the local scale for reducing the risks of water-borne diseases and achieving Sustainable Development Goal 6 in developing countries.
      </br>
      <a href="https://doi.org/10.11648/j.ajep.20241303.12" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">10.11648/j.ajep.20241303.12</a>`,
      journal: "American Journal of Environmental Protection 13(3), 69-83",
      link: "https://doi.org/10.11648/j.ajep.20241303.12",
      keywords: [
        "Intermittent Biosand Filter",
        "Oyster Shell",
        "Filter Cartridge",
        "Madagascar",
        "Water Purification",
        "Sub-Saharan Africa",
      ],
      categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
      date: new Date("2024-07-04"),
    },
    {
      path: "/articles/13",
      auteur: "Franck Cloreil Eboa Mbonjo",
      title:
        "Conditions to access of Drinking Water, Waterborne Diseases and Link with Socio-Environmental Aspects in Peri-Urban Areas Of Douala Littoral Cameroon, Sub-Saharan Africa",
      subTitle:
        "Ngo Boum-Nkot Suzanne, Ebonji Seth Rodrigue, Nlend Yvon Bertil, Tchoumbougnang François",
      abstract: `The conditions of access to drinking water and the risk of occurrence of waterborne diseases in the localities of Dibombari, Bonaléa and Mbanga peri-urban area of Douala Littoral Cameroon were studied. Surveys were carried out in health case to identify individuals suffering from waterborne diseases; the water resources consumed by these individuals were examined in their immediate environment and then their in situ physicochemical parameters were measured using a Hanna HI98192 portable multiparameter. The statistical tests of association of Chi-2 and Spearman's Rho associated with binary logistic regression models were used to predict the risks of occurrence of waterborne diseases. It emerged that waterborne diseases were significantly (P<0.05 and P<0.01) associated with treatment, age, sex, sanitation and proximity to sources of pollution. Individuals over 15 years of age and women were the most affected by waterborne diseases with proportions of 67.71% in Dibombari, 65.38% in Bonaléa and 64.19% in Mbanga. On the pedictive side, the factors associated with an increased risk of waterborne disease were Age (6.39[1.05 ;38.89] in Dibombari; 4.88[1.07 ;30.33] in Bonaléa and 5.79[1.99 ;16.78] in Mbanga) and Distance to sources of pollution (1.13[1.02 ;1.25] in Dibombari; 1.22[1.01 ;1.33] in Bonaléa and 1.17[1.09 ;1.26] in Mbanga). The protective factors were: the type of water (0.80 [0.70 ;0.90] in Dibombi) and the treatment (0.75 [0.65 ;0.86] in Dibombari; 0.76 [0.66 ;0.89] in Bonaléa and 0.05 [0.007 ;0.38] in Mbanga) It is advisable for the development actors in these localities to put an emphasis on the protection of water resources and sanitation because the health of the populations is at stake.
      </br>
      <a href="https://doi.org/10.52155/ijpsat.v38.1.5017" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">10.52155/ijpsat.v38.1.5017 </a>`,
      journal:
        "International Journal of Progressive Sciences and Technologies 38(1), 170-184",
      link: "https://doi.org/10.52155/ijpsat.v38.1.5017 ",
      keywords: [
        "Bonaléa",
        "Waterborne diseases",
        "Drinking water",
        "Health risk",
        "Dibombari",
        "Mbanga",
      ],
      categories: "Gestion des Ressources en Eau et Environnement",
      date: new Date("2023-04-01"),
    },
    {
      path: "/articles/14",
      auteur: "Franck Cloreil Eboa Mbonjo",
      title:
        "Physico-chemical and bacteriological characteristics of groundwater in peri-urban areas of Cameroon, Central Africa: towards a new water management strategy including human-water interface",
      subTitle:
        "Mohammad Bello, Suzanne Ngo Boum-Nkot, Bertil Nlend, Rodrigue Ebonji, Fricelle Song, David Komba, Boris Djieugoue, Enoh Jeanot Fongoh, Andrianaivoravelona Rajaona, Pierre Ravelonandro, François Tchoumbougnang",
      abstract: `hree distinct localities experiencing different dynamics in peri-urban zones where there is coexistence of significant demographic growth, intense agricultural activity and absence of drinking water supply for populations have been investigated. In these sites, the populations rely informally on groundwater and rivers to meet their daily needs. Based on physicochemical and bacteriological parameters (electrical conductivity, pH, temperature, total dissolved solids, Ca<sup>2+</sup>, K<sup>+</sup>, Mg<sup>2+</sup>, Na<sup>+</sup>, NH<sub>4</sub><sup>+</sup>, Cl<sup>−</sup>,> HCO<sub>3</sub><sup>−</sup>, NO<sub>3</sub><sup>−</sup>, SO<sub>4</sub><sup>2−</sup>, Escherichia coli and Salmonella typhi), this study aims to evaluate the origin of mineralization of these waters and their quality for human consumption. Results show that the water sources are weakly mineralized and acidic. The mineralization is controlled by alteration of silicates. In addition, the mineralization is also influenced by anthropogenic factors, supported by several indices, namely detection of bacteria in all water types, NH<sub>4</sub><sup>+</sup> concentrations above those expected for natural aerobic groundwater and surface water (< 0.2 mg.L<sup>−1</sup>) and high variability of facies from one water type to another and from one season to another. Based on the Water Quality Index, water resources are unsuitable for human consumption. This is affirmed by the presence of bacteria in all water samples and high content of NO<sub>3</sub><sup>−</sup> above World Health Organization standards.
      </br>
      <a href="https://doi.org/10.1007/s11356-025-36562-6" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">10.1007/s11356-025-36562-6</a>`,
      journal: "Environmental Science and Pollution Research 44, 1-16",
      link: "https://doi.org/10.1007/s11356-025-36562-6",
      keywords: [
        "Geochemistry",
        "Hydrogeology",
        "Mineralogy",
        "Soil Chemistry",
        "Water Microbiology",
        "Water",
      ],
      categories: "Gestion des Ressources en Eau et Environnement",
      date: new Date("2025-05-31"),
    },
    {
      path: "/articles/15",
      auteur: "Ravaloera Antsatiana",
      title:
        "Vulnérabilité des ressources en eau face au décharge non contrôle cas du système lagunaire autour de la décharge d'Andralanitra",
      subTitle:
        "Rakoto David Rambinintsoa, Andrianaivoravelona Rafihavanana Rajaona, Fidihery Toky Tantely, Andriamanampisoa Lova Marcellin",
      abstract: `<b>[FRS]</b> La contamination des eaux environnantes par les éléments chimiques issue de la décharge d’Andralanitra notamment les polluants de type NOx et les risques sanitaire ont été évalués et confirmés à partir du calcul des indices de pollution des eaux par la décharge LWPI et l’indice de risque sanitaire QD et HI durant la période Janvier, Février et Mars 2021. Les résultats issus des 24 échantillons d’eau reparties sur 12 points de prélèvements, ont mis en évidence que les eaux souterraines situées dans l’aquifère aval de la décharge et les eaux de surfaces des marais d’Andranofotsy et d’Amboahirana sont fortement polluée et ayant un fort impact de la décharge avec des valeurs de LWPI supérieur à 3,83. Les valeurs de HI et QD par ingestion des eaux des puits Pep 2 et Pep 3 ainsi que les eaux des marais d’Amboahirana et d’Andranofotsy ont été tous supérieur à la limite suggérée par USEPA (HI = 1 et QD = 1). Les polluants chimiques de type NOx ont été les contribuant majeur au risque sanitaire par ingestion de ces eaux. Ces résultats d’évaluation des risques sanitaires confirment le réel danger pour la population comme la méthémoglobinémie par ingestion des eaux de puits et du marais aux environs de la décharge d’Andralanitra après un certain temps de sa vie. Pour sauver des vies et améliorer la qualité de l’écosystème, des études concernant aux différentes techniques de dépollution doivent être menées tout en pensant déjà à la fermeture de ce site.
      </br>
      </br>
<b>[ENG]</b> The contamination of surrounding waters by chemical elements from the Andralanitra landfill, in particular NOx type pollutants and health risks, were assessed and confirmed based on the calculation of the water pollution indices by the LWPI landfill and the water pollution index. health risk QD and HI during the period January, February and March 2021. The results from 24 water samples distributed over 12 sampling points showed that the groundwater located in the aquifer downstream of the landfill and the surface water of the Andranofotsy and Amboahirana marshes are heavily polluted. and having a high landfill impact with LWPI values greater than 3.83. The HI and QD values by ingestion of water from Pep 2 and Pep 3 wells as well as water from the Amboahirana and Andranofotsy marshes were all higher than the limit suggested by USEPA (HI = 1 and QD = 1). Chemical pollutants of the NOx type were the major contributor to the health risk through ingestion of this water. These health risk assessment results confirm the real danger for the population such as methemoglobinemia from ingestion of well water and marsh water around the Andralanitra landfill after a certain period of its life. To save lives and improve the quality of the ecosystem, studies on different depollution techniques must be carried out.
</br>
      <a href="http://madarevues.recherches.gov.mg/?VULNERABILITE-DES-RESSOURCES-EN-EAU-FACE-AU-DECHARGE-NON-CONTROLE-CAS-DU" style="color:hsl(165,100%,37%);font-weight: bold;text-decoration: underline;">Madamines, volume 1, 2024, ISSN 2220-0681 </a>
`,
      journal: "Madamines",
      link: "http://madarevues.recherches.gov.mg/?VULNERABILITE-DES-RESSOURCES-EN-EAU-FACE-AU-DECHARGE-NON-CONTROLE-CAS-DU",
      keywords: [
        "Polluants Chimiques NOx",
        "Décharge d'Andralanitra",
        "eaux souterraines",
        "eaux de surface",
        "Indice de pollution",
        "Indice de risque sanitaire",
      ],
      categories: "Eau et environement",
      date: new Date("2024-01-01"),
    },
  ],
};

const searchFixture = [
  {
    auteur: "Odilon RASOLONIRINA",
    date: [new Date("2023"), new Date("2026")],
    description:
      "Modélisation d'une station d'épuration des eaux usées pour la ville d’Antananarivo en appliquant les interactions des activités abiotiques.",
    image: "./assets/images/profile/Image4.jpg",
    categories: "Eau et environnement",
  },
  {
    auteur: "Tiffanny Diony RAKOTONIAINA",
    date: [new Date("2022"), new Date("2025")],
    description:
      "Evaluation de la dynamique des pesticides au sein d’un écosystème lagunaire : Cas du Marai Masay. Identification des sources de contamination et processus de transformation des contaminants.",
    image: "./assets/images/profile/Image5.jpg",
    categories: "Eau et environnement",
  },
  {
    auteur: "Chipinda Siradji",
    date: [new Date("2024"), new Date("2027")],
    description:
      "Conception et Caractérisation des propriétés thermo-hydriques et acoustiques des briques en argile kaolin stabilisé aux coques de noix des cocos. Unité de Recherche en Génie des Procédés et Génie de l’Environnement (URGPGE), Université d’Anatananarivo.",
    image: "./assets/images/profile/Image13.png",
    categories: "Chimie des Matériaux",
  },
  {
    auteur: "Rakotoarimanana Esthèle",
    date: [new Date("2024"), new Date("2027")],
    description:
      "Conception de peinture biosourcée par le procédé de mise en émulsion par inversion de phase des résines d'origines végétales de Madagascar et sélection des tensioactifs. Thèse en co-direction : Université Gaston Berger (Saint Louis, Sénégal), Université d'Antananarivo et Toulouse INP). Financer par Projet IDBio.",
    image: "./assets/images/profile/Image10.jfif",
    categories: "Génie des procédés, Génie de l'environnement",
  },
  {
    auteur: "ANDRIANJOHANY Nambinintsoa Fiononana Sedera",
    date: [new Date("2024"), new Date("2027")],
    description:
      "Valorisation de trois espèces d'algues de la côte est de Madagascar comme biofertilisant pour l'agriculture. En collaboration avec URGPGE Madagascar.",
    image: "./assets/images/profile/Image9.jpg",
    categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
  },
  {
    auteur: "Julie Tantely MITANTSOA",
    date: [new Date("2021"), new Date("2024")],
    description:
      "Etude et production de bioplastique. Thèse en collaboration avec le laboratoire Toulouse Biotechnology Institute (TBI) de l’INSA de Toulouse, France. Thèse financée par la Bourse Eiffel du Gouvernement Français.",
    image: "./assets/images/profile/Image2.jpg",
    categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
  },
  {
    auteur: "Zongo Karim",
    date: [new Date("2022"), new Date("2025")],
    description:
      "Valorisation énergétique et agricole de trois biomasses : effet des biochars sur les propriétés physique et hydrodynamique d'un sol aride. Thèse en cotutelle entre Université Nazi Boni (Burkina Faso, Laboratoire de Matériaux, d'Héliophysique et Environnement) et Université d'Antananarivo (Madagascar, URGPGE). Financer par Projet AFRIDI (Union européenne).",
    image: "./assets/images/profile/Image11.jpg",
    categories: "Génie de l'Eau, Génie de l'Environnement",
  },
];

const thesesFixture = [
  {
    title:
      "Etude de la stabilite et de la rheologie des emulsion de l'huile d'avocat de Madagascar",
    auteur: "ANDRIANONY Fara Arimalala",
    directeur:
      "RAVELONANDRO Pierre Hervé, Professeur Titulaire à la Faculté des Sciences, Université d’Antananarivo",
    date: new Date("1 august 2022"),
    doc: "/assets/theses/these1.pdf",
  },
  {
    title:
      "Contribution au traitement des boues et des sols pollués par des hydrocarbures : Optimisation et approche de modélisation du procédé",
    auteur: "RAJAONA RAFIHAVANANA Andrianaivoravelona",
    directeur:
      "RAVELONANDRO Pierre Hervé, Professeur Titulaire à la Faculté des Sciences, Université d’Antananarivo",
    date: new Date("18 march 2015"),
    doc: "/assets/theses/these2.pdf",
  },
  {
    title:
      "Développement et caractérisation de matériaux photocatalytiques à base de MXène en vue de leurs applications pour la photoréduction du Chrome hexavalent",
    auteur: "Rija RAZAFINTSALAMA",
    directeur:
      "RAVELONANDRO Pierre Hervé, Professeur Titulaire à la Faculté des Sciences, Université d’Antananarivo",
    coDirecteur:
      "CHAUDHARY Yatendra Singh, Senior principal Scientist à l’Institute of Minerals Materials Technology (IMMT)",
    date: new Date("28 february 2024"),
    doc: "/assets/theses/these3.pdf",
  },
  {
    title:
      "Etude des potentialités chimique et biologique d’une espèce d’algue marine de Madagascar Eucheuma denticulatum : valorisation en nutrition et santé",
    auteur: "ZAMANILEHA Elando Fréda",
    directeur:
      "RAVELONANDRO Pierre Hervé, Professeur Titulaire à la Faculté des Sciences, Université d’Antananarivo",
    coDirecteur: "BEDOUX Gilles, Professeur Titulaire, Université Bretagne Sud",
    date: new Date("26 march 2025"),
    doc: "/assets/theses/these4.pdf",
  },
  {
    title:
      "Qualité des ressources en eau et sante des populations en zone périurbaine d’Afrique subsaharienne : cas des localités de Dibombari, Bonalea et Mbanga, littoral-Cameroun",
    auteur: "Eboa Mbonjo Franck Cloreil",
    directeur:
      "RAVELONANDRO Pierre Hervé, Professeur Titulaire à la Faculté des Sciences, Université d’Antananarivo",
    coDirecteur:
      "Tchoumbougnang François Professeur Titulaire à l’Institut des Sciences Halieutiques, Université de Douala",
    date: new Date("22 october 2024"),
    doc: "/assets/theses/these5.pdf",
  },
];

const annuaireFixture = [
  {
    img: "/assets/images/profile/Image8.jpg",
    name: "Pr. RAVELONANDRO Pierre Hervé",
    status:
      "Professeur titulaire à l’Université d’Antananarivo, Responsable laboratoire URGPGE et Responsable du Parcours Génie de l’Eau et Génie de l’Environnement, Faculté des Science de l’Université d’Antananarivo.",
    speciality: "génie des procédés et bioprocédés",
    email: "phravelona@yahoo.com",
    tel: "+261 32 02 261 61",
    searchNow: [],
    publication: [
      {
        path: "/articles/1",
        title:
          "Elaboration and characterization of bioplastic films based on bitter cassava starch (Manihot esculenta) reinforced by chitosan extracted from crab (Shylla seratta) shells",
        subTitle:
          "Julie Tantely Mitantsoa, Pierre Hervé Ravelonandro, Fara Arimalala Andrianony, Rajaona Rafihavanana Andrianaivoravelona.",
        categories: "Génie des procédés",
        years: "2021",
        month: "December",
      },
      {
        path: "/articles/2",
        title:
          "Modeling and kinetics study of Avocado oil extraction from Madagascar using different mathematical models",
        subTitle:
          "Andrianony Fara Arimalala, Ravelonandro Pierre Hervé, Rajaona Rafihavanana.",
        categories: "Génie des procédés",
        years: "2022",
        month: "May",
      },
      {
        path: "/articles/3",
        title:
          "Contamination by NOx type Pollutants in the Leach Ate from the Andralanitra Garbage Dump (Antananarivo Madagascar)",
        subTitle:
          "Andrianaivoravelona Rafihavanana Rajaona, Pierre Hervé Ravelonandro, Julie Tantely Mitantsoa, et Fara Arimalala Andrianony.",
        categories: "Eau et environnement",
        years: "2022",
        month: "May",
        day: "24",
      },
      {
        path: "/articles/4",
        title:
          "Evaluation of the vulnerability of groundwater to nitrogen pollution in the commune of Mananara Avaratra by the SINTACS method",
        subTitle:
          "Elando Fréda ZAMANILEHA, Yves Jean Michel MONG, et Pierre RAVELONANDRO.",
        categories: "Eau et environnement",
        years: "2022",
        month: "June",
      },
      {
        path: "/articles/5",
        title:
          "The Use of FTIR Spectroscopy as a Tool for the Seasonal Variation Analysis and for the Quality Control of Polysaccharides from Seaweeds.",
        subTitle:
          "Vandanjon Laurent, Burlot Anne-Sophie, Zamanileha Elando Fréda, Douzenel Philippe, Ravelonandro Pierre Hervé, Bourgougnon Nathalie, Bedoux Gilles",
        categories: "Eau et environnement",
        years: "2023",
        month: "September",
        day: "01",
      },
      {
        path: "/articles/6",
        title:
          "Efficient Photocatalytic Reduction of Hexavalent Chromium by BiVO<sub>4</sub>- Decorated MXene Photocatalysts and Their Charge Carrier Dynamics.",
        subTitle:
          "Razafintsalama A. Rija, Mishra Rajashree P., Sahoo Manas K., Mrinalini Madoori, Sahoo Bismaya, Ravelonandro Pierre, Chaudhary Yatendra S.",
        categories: "Eau et environnement",
        years: "2023",
        month: "September",
        day: "23",
      },
      {
        path: "/articles/9",
        title:
          "Various Approaches to Fourier-Transform Infrared Spectroscopy (FTIR) for Bioanalytical and Biotechnological Applications in Marine Algae",
        subTitle:
          "Elando Fréda ZAMANILEHA, Julie Tantely Mitantsoa, Picardino Frienduc Vaonalamihanta, Andriamanarivosoa Rija Razafintsalama, Fara Arimalala Andrianony and Pierre Hervé Ravelonandro",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "October",
        day: "01",
      },
      {
        path: "/articles/10",
        title: `Biochemical Composition and Seasonal Variations of the Madagascar Algae <i>Eucheuma denticulatum</i> (<i>Solieriaceae</i>, Rhodophyta)`,
        subTitle:
          "Elando Fréda ZAMANILEHA, Anne-Sophie Burlot, Thomas Latire, Christel Marty, Philippe Douzenel, Laurent Vandanjon, Nathalie Bourgougnon, Pierre Ravelonandro, Gilles Bedoux",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2025",
        month: "January",
        day: "09",
      },
      {
        path: "/articles/7",
        title:
          "Feasibility Study of the Implementation of a Wastewater Treatment Plant in the City of Tulear Madagascar 2018.",
        subTitle:
          "Rajaona Andrianaivoravelona Rafihavanana, Ravelonandro Pierre Hervé, Ravaloera Antsatiana, Andriamanampisoa Lova Marcellin",
        categories: "Eau et environnement",
        years: "2023",
        month: "July",
        day: "04",
      },
      {
        path: "/articles/8",
        title:
          "The Use of Allochthonous Tropical Peat Swamps of Antananarivo for Dyes Elimination in Effluents.",
        subTitle: "Rajoelisoa Andriamalala, Ravelonandro Pierre Hervé",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2022",
        month: "November",
        day: "21",
      },
      {
        path: "/articles/4",
        title:
          "Evaluation of the vulnerability of groundwater to nitrogen pollution in the commune of Mananara Avaratra by the SINTACS method.",
        subTitle:
          "Elando Fréda ZAMANILEHA, Yves Jean Michel MONG, Pierre RAVELONANDRO.",
        categories: "Eau et environnement",
        years: "2022",
        month: "June",
        day: "01",
      },
      {
        path: "/articles/11",
        title: `Microbial production of thermoplastic-targeted biopolymer composites made of polyhydroxybutyrate and protein by <i>Cupriavidus necator</i> CECT 4623 strain: Bacterial accumulation, thermal characterizations, direct extrusion processing and mechanical properties`,
        subTitle:
          "Julie Tantely MITANTSOA, Xavier Cameleyre, Carole Molina Jouve, Philippe Evon, Guadalupe Vaca-Medina, Pierre Hervé Ravelonandro.",
        categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
        years: "2025",
        month: "April",
        day: "01",
      },
      {
        path: "/articles/12",
        title:
          "Design of an Intermittent Biosand Filter Amended with Oyster Shell Powders for the Improvement of Household Water Quality in Sub-Saharan Africa and Madagascar",
        subTitle:
          "Franck Cloreil Eboa Mbonjo, Hervé Pierre Ravelonandro, Suzanne Boum-Nkot Ngo, Rodrigue Seth Ebonji, Rodrigue Seth Ebonji, Rajaona Fiahavanana Andrianaivoravelona, François Tchoumbougnang",
        categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "July",
        day: "04",
      },
    ],
  },
  {
    img: "/assets/images/profile/Image6.jpg",
    name: "Dr. ANDRIANONY Fara Arimalala",
    status:
      "Enseignante dans le parcours Génie de l’Eau et Génie de l’Environnement, Faculté des Sciences, Université d’Antananarivo.",
    speciality: "génie des procédés",
    email: "arimalala.andrianony@univ-antananarivo.mg",
    tel: "+261 32 45 129 23",
    searchNow: [],
    publication: [
      {
        path: "/articles/1",
        title:
          "Elaboration and characterization of bioplastic films based on bitter cassava starch (Manihot esculenta) reinforced by chitosan extracted from crab (Shylla seratta) shells",
        subTitle:
          "Julie Tantely Mitantsoa, Pierre Hervé Ravelonandro, Fara Arimalala Andrianony, Rajaona Rafihavanana Andrianaivoravelona.",
        categories: "Génie des procédés",
        years: "2021",
        month: "December",
      },
      {
        path: "/articles/2",
        title:
          "Modeling and kinetics study of Avocado oil extraction from Madagascar using different mathematical models",
        subTitle:
          "Andrianony Fara Arimalala, Ravelonandro Pierre Hervé, Rajaona Rafihavanana.",
        categories: "Génie des procédés",
        years: "2022",
        month: "May",
      },
      {
        path: "/articles/3",
        title:
          "Contamination by NOx type Pollutants in the Leach Ate from the Andralanitra Garbage Dump (Antananarivo Madagascar)",
        subTitle:
          "Andrianaivoravelona Rafihavanana Rajaona, Pierre Hervé Ravelonandro, Julie Tantely Mitantsoa, et Fara Arimalala Andrianony.",
        categories: "Eau et environnement",
        years: "2022",
        month: "May",
        day: "24",
      },
      {
        path: "/articles/9",
        title:
          "Various Approaches to Fourier-Transform Infrared Spectroscopy (FTIR) for Bioanalytical and Biotechnological Applications in Marine Algae",
        subTitle:
          "Elando Fréda ZAMANILEHA, Julie Tantely Mitantsoa, Picardino Frienduc Vaonalamihanta, Andriamanarivosoa Rija Razafintsalama, Fara Arimalala Andrianony and Pierre Hervé Ravelonandro",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "October",
        day: "01",
      },
    ],
  },
  {
    img: "/assets/images/profile/Image7.jpg",
    name: "Dr. ANDRIANAIVORAVELONA Rajaona Fihavanana",
    status:
      "Enseignant dans le parcours Génie de l’Eau et génie de l’Environnement, Faculté des Sciences, Université d’Antananarivo.",
    speciality: "Eau et environnement",
    email: "rajaonaandrianaivoravelona@yahoo.fr",
    tel: "+261 33 28 348 70",
    searchNow: [],
    publication: [
      {
        path: "/articles/1",
        title:
          "Elaboration and characterization of bioplastic films based on bitter cassava starch (Manihot esculenta) reinforced by chitosan extracted from crab (Shylla seratta) shells",
        subTitle:
          "Julie Tantely Mitantsoa, Pierre Hervé Ravelonandro, Fara Arimalala Andrianony, Rajaona Rafihavanana Andrianaivoravelona.",
        categories: "Génie des procédés",
        years: "2021",
        month: "December",
      },
      {
        path: "/articles/2",
        title:
          "Modeling and kinetics study of Avocado oil extraction from Madagascar using different mathematical models",
        subTitle:
          "Andrianony Fara Arimalala, Ravelonandro Pierre Hervé, Rajaona Rafihavanana.",
        categories: "Génie des procédés",
        years: "2022",
        month: "May",
      },
      {
        path: "/articles/3",
        title:
          "Contamination by NOx type Pollutants in the Leach Ate from the Andralanitra Garbage Dump (Antananarivo Madagascar)",
        subTitle:
          "Andrianaivoravelona Rafihavanana Rajaona, Pierre Hervé Ravelonandro, Julie Tantely Mitantsoa, et Fara Arimalala Andrianony.",
        categories: "Eau et environnement",
        years: "2022",
        month: "May",
        day: "24",
      },
      {
        path: "/articles/12",
        title:
          "Design of an Intermittent Biosand Filter Amended with Oyster Shell Powders for the Improvement of Household Water Quality in Sub-Saharan Africa and Madagascar",
        subTitle:
          "Franck Cloreil Eboa Mbonjo, Hervé Pierre Ravelonandro, Suzanne Boum-Nkot Ngo, Rodrigue Seth Ebonji, Rodrigue Seth Ebonji, Rajaona Fiahavanana Andrianaivoravelona, François Tchoumbougnang",
        categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "July",
        day: "04",
      },
    ],
  },
  {
    img: "/assets/images/profile/Image1.jpg",
    name: "Dr. RAZAFINTSALAMA Andriamanarivosoa Rija",
    status: "Docteur, Enseignant",
    researchGate: "https://www.researchgate.net/profile/A-Rija-Razafintsalama",
    speciality: "Génie des procédés",
    email: "rijarazafintsalama@gmail.com",
    tel: "+261 34 16 633 69",
    searchNow: [],
    publication: [
      {
        path: "/articles/6",
        title:
          "Efficient Photocatalytic Reduction of Hexavalent Chromium by BiVO<sub>4</sub>- Decorated MXene Photocatalysts and Their Charge Carrier Dynamics.",
        subTitle:
          "Mishra Rajashree P., Sahoo Manas K., Mrinalini Madoori, Sahoo Bismaya, Ravelonandro Pierre, Chaudhary Yatendra S.",
        categories: "Eau et environnement",
        years: "2023",
        month: "September",
        day: "23",
      },
      {
        path: "/articles/9",
        title:
          "Various Approaches to Fourier-Transform Infrared Spectroscopy (FTIR) for Bioanalytical and Biotechnological Applications in Marine Algae",
        subTitle:
          "Julie Tantely Mitantsoa, Picardino Frienduc Vaonalamihanta, Andriamanarivosoa Rija Razafintsalama, Fara Arimalala Andrianony and Pierre Hervé Ravelonandro",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "October",
        day: "01",
      },
    ],
  },
  {
    img: "/assets/images/profile/Image3.jpg",
    name: "Dr. ZAMANILEHA Elando Fréda",
    status: "Docteur, Enseignant",
    researchGate:
      "https://www.researchgate.net/profile/Elando-Freda-Zamanileha?ev=hdr_xprf",
    orcid: "https://orcid.org/0000-0002-1358-1639",
    speciality: "Chimie appliquée, Biotechnologie",
    email: ["elando.zamanileha@urgpge-ua.mg", "elando.zamanileha@outlook.com"],
    tel: "+261 34 03 271 30",
    searchNow: [],
    publication: [
      {
        path: "/articles/10",
        title: `Biochemical Composition and Seasonal Variations of the Madagascar Algae <i>Eucheuma denticulatum</i> (<i>Solieriaceae</i>, Rhodophyta)`,
        subTitle:
          "Anne-Sophie Burlot, Thomas Latire, Christel Marty, Philippe Douzenel, Laurent Vandanjon, Nathalie Bourgougnon, Pierre Ravelonandro, Gilles Bedoux",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2025",
        month: "January",
        day: "09",
      },
      {
        path: "/articles/9",
        title:
          "Various Approaches to Fourier-Transform Infrared Spectroscopy (FTIR) for Bioanalytical and Biotechnological Applications in Marine Algae",
        subTitle:
          "Julie Tantely Mitantsoa, Picardino Frienduc Vaonalamihanta, Andriamanarivosoa Rija Razafintsalama, Fara Arimalala Andrianony and Pierre Hervé Ravelonandro",
        categories: "Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "October",
        day: "01",
      },
      {
        path: "/articles/4",
        title:
          "Evaluation of the vulnerability of groundwater to nitrogen pollution in the commune of Mananara Avaratra by the SINTACS method.",
        subTitle: "Yves Jean Michel MONG, Pierre RAVELONANDRO.",
        categories: "Eau et environnement",
        years: "2022",
        month: "June",
        day: "01",
      },
    ],
  },
  {
    img: "/assets/images/profile/Image12.jfif",
    name: "Dr. Franck Cloreil Eboa Mbonjo",
    status: "Docteur, chercheur.",
    researchGate:
      "https://www.researchgate.net/profile/Franck-Cloreil-Eboa-Mbonjo-2",
    orcid: "https://orcid.org/0000-0002-4953-4471",
    speciality: "Gestion des Ressources en Eau et Environnement",
    email: ["eboacloreil@yahoo.fr"],
    tel: "+237 97809558 / +261 343203870",
    searchNow: [],
    publication: [
      {
        path: "/articles/12",
        title:
          "Design of an Intermittent Biosand Filter Amended with Oyster Shell Powders for the Improvement of Household Water Quality in Sub-Saharan Africa and Madagascar",
        subTitle:
          "Hervé Pierre Ravelonandro, Suzanne Boum-Nkot Ngo, Rodrigue Seth Ebonji, Rodrigue Seth Ebonji, Rajaona Fiahavanana Andrianaivoravelona, François Tchoumbougnang",
        categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
        years: "2024",
        month: "July",
        day: "04",
      },
      {
        path: "/articles/13",
        title:
          "Conditions to access of Drinking Water, Waterborne Diseases and Link with Socio-Environmental Aspects in Peri-Urban Areas Of Douala Littoral Cameroon, Sub-Saharan Africa",
        subTitle:
          "Ngo Boum-Nkot Suzanne, Ebonji Seth Rodrigue, Nlend Yvon Bertil, Tchoumbougnang François",
        categories: "Génie des procédés, Chimie appliquée & Biotechnologie",
        years: "2023",
        month: "April",
        day: "01",
      },
    ],
  },
];

const navDashboard = {
  logo: {
    path: "/",
    img: Logo,
    alt: "URGPGE-logo",
  },
  dropDown: [
    {
      path: "/dashboard/profile",
      name: "Profile",
      icon: <MdPersonOutline />,
    },
  ],
  logout: {
    name: "Se déconnécter",
    icon: <MdLogout />,
  },
};

const asideBaDashboard = [
  {
    label: "Pages",
    nav: [
      {
        path: "/dashboard",
        name: "Acceuil",
        icon: <AiOutlineHome />,
        child: [],
      },
      {
        path: "profile",
        name: "Profile",
        icon: <MdPersonOutline />,
        child: [],
      },
    ],
  },
  {
    label: "Contenus",
    nav: [
      {
        path: "dashboard/article",
        name: "Articles",
        icon: <MdOutlineBook />,
        child: [
          {
            path: "/dashboard/article",
            label: "Tous les Articles",
          },
          {
            path: "/dashboard/article/new",
            label: "Créer",
          },
        ],
      },
      {
        path: "/thesis",
        name: "Thèses",
        icon: <MdLibraryBooks />,
        child: [
          {
            path: "/thesis",
            label: "Tous les thèses",
          },
          {
            path: "/thesis/new",
            label: "Créer",
          },
        ],
      },
      // {
      //   path: "search",
      //   name: "Thèses en cours",
      //   icon: <MdOutlineLibraryAdd />,
      //   child: [
      //     {
      //       path: "search",
      //       label: "Tous les thèses en cours",
      //     },
      //     {
      //       path: "search/new",
      //       label: "Créer",
      //     },
      //   ],
      // },
    ],
  },
  {
    label: "Admin Users",
    nav: [
      {
        path: "/users",
        name: "Utilisateurs",
        icon: <MdOutlinePeople />,
        child: [],
      },
    ],
  },
];

const ongletsProfileDashboard = ["Apérçu", "Editer", "Changer mot de passe"];

const overviewData = [
  {
    label: "Á Propos",
    child: [],
  },
  {
    label: "Détails",
    child: [
      {
        label: "Nom d'utilisateur",
        user: "username",
      },
      {
        label: "Nom",
        user: "lastname",
      },
      {
        label: "Prénom",
        user: "firstname",
      },
      {
        label: "Niveau",
        user: "graduate",
      },
      {
        label: "Email",
        user: "email",
      },
      {
        label: "Spécialité",
        user: "speciality",
      },
      {
        label: "Tel",
        user: "tel",
      },
    ],
  },
];

const graduate = {
  pr: "Professeur",
  dr: "Docteur",
  etudiant: "Etudiant",
};

const edit = {
  file: "Photo",
  other: [
    {
      type: "textarea",
      label: "Déscription",
      placeholder: "Pétite déscription",
      name: "bio",
    },
    {
      type: "text",
      label: "Nom d'utilisateur",
      placeholder: "ex: rakoto",
      name: "username",
    },
    {
      type: "text",
      label: "Nom",
      placeholder: "ex: RANDRIA",
      name: "lastname",
    },
    {
      type: "text",
      label: "Pénom",
      placeholder: "ex: Rakoto André",
      name: "firstname",
    },
    {
      type: "email",
      label: "Email",
      placeholder: "ex: rakotoandre@gmail.com",
      name: "email",
    },
    {
      type: "radio",
      label: "Niveau",
      name: "graduate",
      options: [
        {
          value: "etudiant",
          label: "Etudiant",
        },
        {
          value: "pr",
          label: "Professeur",
        },
        {
          value: "dr",
          label: "Docteur",
        },
      ],
    },
    {
      type: "select",
      label: "Spécialité",
      name: "speciality",
      options: [
        {
          value: "Chimie",
          label: "Chimie",
        },
        {
          value: "Eau et Environement",
          label: "Eau et Environement",
        },
        {
          value: "Génie des procédés",
          label: "Génie des procédés",
        },
        {
          value: "Bioprocédés",
          label: "Bioprocédés",
        },
      ],
    },
    {
      type: "text",
      label: "Tel",
      placeholder: "+261 00 00 000 00",
      name: "tel",
    },
  ],
  button: "Enrégistrer",
};

const ChangePwd = [
  {
    type: "password",
    label: "Actuel",
    placeholder: "Mot de passe actuel",
    name: "actual",
  },
  {
    type: "password",
    label: "Nouveau",
    placeholder: "Nouveau mot de passe",
    name: "password",
  },
  {
    type: "password",
    label: "Confirmer",
    placeholder: "Mot de passe de confirmation",
    name: "passwordConfirm",
  },
];

const DataClient = {
  footer,
  auth,
  navbar,
  hero,
  formation,
  presentation,
  homeFormation,
  articleFixture,
  searchFixture,
  thesesFixture,
  annuaireFixture,
  navDashboard,
  asideBaDashboard,
  ongletsProfileDashboard,
  overviewData,
  graduate,
  edit,
  ChangePwd,
};
export default DataClient;
